// Money typed into a payment form: never negative, never more than the limit it belongs to.

/** Digits with at most one dot, no minus sign and no "e": "-12", "1e3" and "5.5.5" become "12", "13" and "5.55". */
export const cleanAmount = (value) => {
  const text = String(value ?? "").replace(/[^0-9.]/g, "");
  const dot = text.indexOf(".");
  return dot === -1 ? text : text.slice(0, dot + 1) + text.slice(dot + 1).replace(/\./g, "");
};

/** The typed amount as text, cut down to `max` when it goes over (max omitted or not a number: no limit). */
export const limitAmount = (value, max) => {
  const text = cleanAmount(value);
  const limit = Number(max);
  if (text === "" || max === undefined || max === null || max === "" || Number.isNaN(limit)) return text;
  return parseFloat(text) > limit ? String(Math.max(0, limit)) : text;
};

/** True when the text has a minus sign or exponent, i.e. cleanAmount changed more than formatting. */
export const hadBadChars = (value) => /[-+eE]/.test(String(value ?? ""));
